
import { defineComponent, onMounted, ref } from 'vue';
import axios from "axios";
import { message } from "ant-design-vue";
import { Tool } from "@/util/tool";
import { useRoute } from "vue-router";

export default defineComponent({
  name: 'Doc',
  setup() {

    const route = useRoute()
    const docs = ref()

    const level1 = ref()
    level1.value = []
    const html = ref()

    // 文档页面加载默认选中的节点
    const defaultSelectedKeys = ref()
    defaultSelectedKeys.value = []

    // 当前选中文档
    const doc = ref()
    doc.value = {}

    // 内容查询
    const handleQueryContent = (id: number) => {
      axios.get("/doc/find-content/" + id).then((response) => {
        const data = response.data
        if (data.success) {
          // 给富文本框赋值
          html.value = data.content
        } else {
          message.error(data.message)
        }
      })
    }

    // 数据查询
    const handleQuery = () => {
      axios.get("/doc/all/" + route.query.ebookId).then((res) => {
        const data = res.data
        if (data.success) {
          docs.value = data.content

          level1.value = []
          level1.value = Tool.array2Tree(docs.value, 0)

          if (Tool.isNotEmpty(level1)) {
            defaultSelectedKeys.value = [level1.value[0].id]
            handleQueryContent(level1.value[0].id)

            // 初始显示文档信息
            doc.value = level1.value[0]
          }
        } else {
          message.error(data.message)
        }
      })
    }

    const onSelect = (selectedKeys: any, info: any) => {
      console.log(selectedKeys, info)
      if (Tool.isNotEmpty(selectedKeys)) {
        // 选中某一节点时，加载该节点的文档信息
        doc.value = info.selectedNodes[0].props

        // 加载内容
        handleQueryContent(selectedKeys[0])
      }
    }

    // 点赞
    const vote = () => {
      axios.get("/doc/vote/" + doc.value.id).then((res) => {
        const data = res.data
        if (data.success) {
          doc.value.voteCount++;
        } else {
          message.error(data.message)
        }
      })
    }

    onMounted(() => {
      handleQuery()
    })

    return {
      level1,
      html,
      onSelect,
      defaultSelectedKeys,
      doc,
      vote
    }
  }
})
